import { Component } from '@angular/core';
declare let $: any

interface MenuItem {
  id: number;
  title: string;
  imageUrl: string;
  routerLink?: string;
}

@Component({
  selector: 'app-fleetdiag-dashboard-pro',
  templateUrl: './fleetdiag-dashboard-pro.component.html',
  styleUrls: ['./fleetdiag-dashboard-pro.component.scss'],
})
export class FleetdiagDashboardProComponent {
  menuItems: MenuItem[] = [
    {
      id: 1,
      title: 'پارامترهای زنده',
      routerLink: 'live-data',
      imageUrl: '../../../assets/Img/fleetdiag/پارامترهای زنده خودرو.png',
    },
    {
      id: 3,
      title: 'خطاهای ECU',
      routerLink: 'ecu-status',
      imageUrl: '../../../assets/Img/fleetdiag/خطاهای ECU.png',
    },
    {
      id: 2,
      title: 'وضعیت مانیتورهای OBD',
      routerLink: 'obd-status',
      imageUrl: '../../../assets/Img/fleetdiag/وضعیت مانیتورهای OBD.png',
    },
    {
      id: 3,
      title: 'شاخص آلایندگی',
      routerLink: 'health-report',
      imageUrl: '../../../assets/Img/fleetdiag/شاخص آلایندگی.png',
    },
    {
      id: 4,
      title: 'کیفیت رانندگی',
      routerLink: 'driving-quality',
      imageUrl: '../../../assets/Img/fleetdiag/کیفیت رانندگی.png',
    },
  ];

}
